function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 4h13v10H3V4z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.246 8.55c-.513 0-.918.45-.918 1 0 .549.414.999.918.999.513 0 .918-.45.918-1 .01-.548-.405-.998-.918-.998zm3.285 0c-.513 0-.918.45-.918 1 0 .549.414.999.918.999.513 0 .918-.45.918-1 0-.548-.405-.998-.918-.998z",
  fill: "#7289DA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.905 1H3.845A1.85 1.85 0 002 2.854v12.168a1.85 1.85 0 001.845 1.854h10.206l-.477-1.665 1.152 1.071 1.089 1.008L17.75 19V2.854A1.85 1.85 0 0015.905 1zm-3.474 11.754s-.324-.387-.594-.729c1.179-.333 1.629-1.071 1.629-1.071a5.15 5.15 0 01-1.035.531c-.45.189-.882.315-1.305.387a6.305 6.305 0 01-2.331-.009 7.555 7.555 0 01-1.323-.387 5.274 5.274 0 01-.657-.306c-.027-.018-.054-.027-.081-.045-.018-.009-.027-.018-.036-.027-.162-.09-.252-.153-.252-.153s.432.72 1.575 1.062c-.27.342-.603.747-.603.747-1.989-.063-2.745-1.368-2.745-1.368 0-2.898 1.296-5.247 1.296-5.247 1.296-.972 2.529-.945 2.529-.945l.09.108c-1.62.468-2.367 1.179-2.367 1.179s.198-.108.531-.261c.963-.423 1.728-.54 2.043-.567.054-.009.099-.018.153-.018a7.336 7.336 0 014.527.846s-.711-.675-2.241-1.143l.126-.144s1.233-.027 2.529.945c0 0 1.296 2.349 1.296 5.247 0 0-.765 1.305-2.754 1.368z",
  fill: "#7289DA"
});

function SvgSocialDiscord(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

SvgSocialDiscord.defaultProps = {
  color: "#000",
  title: "Social Discord"
};
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJyZWFjdC1jb21wb25lbnRzL2ljb25zL1NvY2lhbERpc2NvcmQtZTJiYjY5NjE5NDNiZWUyM2NkZTc4OGVlMDBhOTI0MTcuc3ZnIjs=";
export { SvgSocialDiscord as ReactComponent };